var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3793 2.34855C12.287 1.68011 11.9509 1.06992 11.4361 0.636326C10.9213 0.202734 10.2645 -0.0233544 9.59315 0.0019102C8.9218 0.0271748 8.28371 0.301992 7.80265 0.773061C7.32158 1.24413 7.03183 1.87787 6.98958 2.55138C4.24034 3.69035 1.55324 0.858539 1.55324 0.858539C0.77662 5.53921 3.10648 7.68452 3.10648 7.68452C2.05028 8.65966 0 8.65966 0 8.65966C0 8.65966 1.22706 11 6.6634 11C12.0997 11 12.4259 4.7591 12.4259 4.7591C12.938 4.57192 13.3712 4.21469 13.6536 3.74653C13.9361 3.27838 14.0509 2.72738 13.9792 2.18473C13.4553 2.30961 12.9174 2.36469 12.3793 2.34855Z",
    fill: "#23F6CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter_logo.5a05de0bc011795f11979687a5113cf2.svg";
export { ForwardRef as ReactComponent };